import { faPenLine } from "@fortawesome/pro-duotone-svg-icons";
import { isAdmin as isAdminSignal, userData } from "../Common/Store/CommonSignals";
import ColorChangingIcon from "../Common/UI/ColorChangingIcon";
import { userBelongsToUserGroup } from "../Utilities/AuthorizationUtil";

function EditButton({ component, onClick, data, name }) {
  const userRolePerms = userData.value?.permissions;
  const userIsAdmin = isAdminSignal.value;
  const userEmail = userData.value?.userEmail;

  const userIsCoOwnerViaUserGroup = data?.coOwners?.some(
    (co) => co.isUserGroup && co.userGroupId && userBelongsToUserGroup(userEmail, co.userGroupId)
  );

  const userHasModifyPermissionViaUserGroup = data?.sharedPermission?.some(
    (sp) =>
      sp.isUserGroup &&
      sp.userGroupId &&
      sp.permission === "Modify" &&
      userBelongsToUserGroup(userEmail, sp.userGroupId)
  );

  return (
    <ColorChangingIcon
      icon={faPenLine}
      name={name}
      initialPrimaryColor="#F4A427"
      initialSecondaryColor="#d6562a"
      initialSize={18}
      hoverSize={18}
      padding="0 2px 0 2px"
      hidden={
        !userRolePerms.Modify.includes(component) &&
        !userIsAdmin &&
        data?.owner.toLowerCase() !== userEmail.toLowerCase() &&
        !data?.coOwners.some((co) => co.user.toLowerCase() === userEmail.toLowerCase()) &&
        !userIsCoOwnerViaUserGroup &&
        !data?.sharedPermission?.some(
          (sp) => sp.entity.toLowerCase() === userEmail.toLowerCase() && sp.permission === "Modify"
        ) &&
        !userHasModifyPermissionViaUserGroup
      }
      onClick={onClick}
    />
  );
}

export default EditButton;
